<template>
  <div class="login-container">
    <div class="login-logo">
      <img src="/logo/logo.jpg" alt="企融信科" class="logo-img">
    </div>
    <van-form @submit="onSubmit" class="login-form" :model="loginForm">
      <van-field v-model="loginForm.account" label="账号" placeholder="请输入账号" left-icon="user-o"
        :rules="[{ required: true }]" input-align="right" clearable />
      <van-field v-model="loginForm.pwd" label="密码" type="password" placeholder="请输入密码" left-icon="lock"
        :rules="[{ required: true }]" input-align="right" clearable />
      <div style="padding: 0px 16px; margin-top: 30px;">
        <van-button round block type="info" native-type="submit" class="login-btn">登录</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import request from "@/utils/request";
import useCache from "@/utils/user";
import { Toast } from 'vant';

export default {
  name: 'Login',
  props: {
    source: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      loginForm: {
        account: '',
        pwd: ''
      }
    };
  },
  methods: {
    onSubmit() {
      console.log("==source===>", this.source)

      const tempForm = Object.assign({}, this.loginForm);
      request.post("/User/AccountMng/Login", tempForm).then((res) => {
        useCache.cacheUserData(res.data.data);

        Toast("登录成功");
        this.$router.replace({ name: this.source });
      }).catch(err => {
        Toast(err.message);
      })
    }
  }
};
</script>

<style scoped>
.login-container {
  background-color: #F0F4FF;
  min-height: 100vh;
  padding: 0 16px;
}

.login-logo {
  display: flex;
  justify-content: center;
  padding-top: 120px;
}

.login-btn {
  width: 100%;
  padding: 14px;
  border: none;
  margin-top: 20px; 
  border-radius: 12px;
  background: #1566C1;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.logo-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.login-form {
  margin-top: 60px;
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
</style>